export const PAYMENT_STATUS = {
    DONE: 'Done',
    PENDING: 'Pending'
};
